export default "__VITE_ASSET__ChdRDSsS__"